import _asyncToGenerator from "/Users/daniele.benedetto/Desktop/progetti appius/webconsulenzeesterni/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/Users/daniele.benedetto/Desktop/progetti appius/webconsulenzeesterni/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/Users/daniele.benedetto/Desktop/progetti appius/webconsulenzeesterni/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/Users/daniele.benedetto/Desktop/progetti appius/webconsulenzeesterni/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function V(e) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    n = _ref.insertAt;
  if (!e || typeof document > "u") return;
  var t = document.head || document.getElementsByTagName("head")[0],
    r = document.createElement("style");
  r.type = "text/css", n === "top" && t.firstChild ? t.insertBefore(r, t.firstChild) : t.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
}
V(".rmsc{--rmsc-main: #4285f4;--rmsc-hover: #f1f3f5;--rmsc-selected: #e2e6ea;--rmsc-border: #ccc;--rmsc-gray: #aaa;--rmsc-bg: #fff;--rmsc-p: 10px;--rmsc-radius: 4px;--rmsc-h: 38px}.rmsc *{box-sizing:border-box;transition:all .2s ease}.rmsc .gray{color:var(--rmsc-gray)}.rmsc .dropdown-content{position:absolute;z-index:1;top:100%;width:100%;padding-top:8px}.rmsc .dropdown-content .panel-content{overflow:hidden;border-radius:var(--rmsc-radius);background:var(--rmsc-bg);box-shadow:0 0 0 1px #0000001a,0 4px 11px #0000001a}.rmsc .dropdown-container{position:relative;outline:0;background-color:var(--rmsc-bg);border:1px solid var(--rmsc-border);border-radius:var(--rmsc-radius)}.rmsc .dropdown-container[aria-disabled=true]:focus-within{box-shadow:var(--rmsc-gray) 0 0 0 1px;border-color:var(--rmsc-gray)}.rmsc .dropdown-container:focus-within{box-shadow:var(--rmsc-main) 0 0 0 1px;border-color:var(--rmsc-main)}.rmsc .dropdown-heading{position:relative;padding:0 var(--rmsc-p);display:flex;align-items:center;width:100%;height:var(--rmsc-h);cursor:default;outline:0}.rmsc .dropdown-heading .dropdown-heading-value{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1}.rmsc .clear-selected-button{cursor:pointer;background:none;border:0;padding:0;display:flex}.rmsc .options{max-height:260px;overflow-y:auto;margin:0;padding-left:0}.rmsc .options li{list-style:none;margin:0}.rmsc .select-item{box-sizing:border-box;cursor:pointer;display:block;padding:var(--rmsc-p);outline-offset:-1px;outline-color:var(--rmsc-primary)}.rmsc .select-item:hover{background:var(--rmsc-hover)}.rmsc .select-item.selected{background:var(--rmsc-selected)}.rmsc .no-options{padding:var(--rmsc-p);text-align:center;color:var(--rmsc-gray)}.rmsc .search{width:100%;position:relative;border-bottom:1px solid var(--rmsc-border)}.rmsc .search input{background:none;height:var(--rmsc-h);padding:0 var(--rmsc-p);width:100%;outline:0;border:0;font-size:1em}.rmsc .search input:focus{background:var(--rmsc-hover)}.rmsc .search-clear-button{cursor:pointer;position:absolute;top:0;right:0;bottom:0;background:none;border:0;padding:0 calc(var(--rmsc-p) / 2)}.rmsc .search-clear-button [hidden]{display:none}.rmsc .item-renderer{display:flex;align-items:baseline}.rmsc .item-renderer input{margin:0 5px 0 0}.rmsc .item-renderer.disabled{opacity:.5}.rmsc .spinner{animation:rotate 2s linear infinite}.rmsc .spinner .path{stroke:var(--rmsc-border);stroke-width:4px;stroke-linecap:round;animation:dash 1.5s ease-in-out infinite}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}\n");
import oe, { useEffect as Pe, useState as Ne } from "react";
import { jsx as Te } from "react/jsx-runtime";
var Me = {
    allItemsAreSelected: "All items are selected.",
    clearSearch: "Clear Search",
    clearSelected: "Clear Selected",
    noOptions: "No options",
    search: "Search",
    selectAll: "Select All",
    selectAllFiltered: "Select All (Filtered)",
    selectSomeItems: "Select...",
    create: "Create"
  },
  De = {
    value: [],
    hasSelectAll: !0,
    className: "multi-select",
    debounceDuration: 200,
    options: []
  },
  re = oe.createContext({}),
  ne = function ne(_ref2) {
    var e = _ref2.props,
      n = _ref2.children;
    var _Ne = Ne(e.options),
      _Ne2 = _slicedToArray(_Ne, 2),
      t = _Ne2[0],
      r = _Ne2[1],
      a = function a(c) {
        var u;
        return ((u = e.overrideStrings) == null ? void 0 : u[c]) || Me[c];
      };
    return Pe(function () {
      r(e.options);
    }, [e.options]), Te(re.Provider, {
      value: _objectSpread(_objectSpread(_objectSpread({
        t: a
      }, De), e), {}, {
        options: t,
        setOptions: r
      }),
      children: n
    });
  },
  w = function w() {
    return oe.useContext(re);
  };
import { useEffect as ye, useRef as Qe, useState as J } from "react";
import { useEffect as Fe, useRef as Le } from "react";
function se(e, n) {
  var t = Le(!1);
  Fe(function () {
    t.current ? e() : t.current = !0;
  }, n);
}
import { useCallback as Ke, useEffect as ae, useMemo as We, useRef as _e } from "react";
var He = {
  when: !0,
  eventTypes: ["keydown"]
};
function R(e, n, t) {
  var r = We(function () {
      return Array.isArray(e) ? e : [e];
    }, [e]),
    a = Object.assign({}, He, t),
    c = a.when,
    u = a.eventTypes,
    b = _e(n),
    s = a.target;
  ae(function () {
    b.current = n;
  });
  var p = Ke(function (i) {
    r.some(function (l) {
      return i.key === l || i.code === l;
    }) && b.current(i);
  }, [r]);
  ae(function () {
    if (c && typeof window < "u") {
      var i = s ? s.current : window;
      return u.forEach(function (l) {
        i && i.addEventListener(l, p);
      }), function () {
        u.forEach(function (l) {
          i && i.removeEventListener(l, p);
        });
      };
    }
  }, [c, u, r, s, n]);
}
var f = {
  ARROW_DOWN: "ArrowDown",
  ARROW_UP: "ArrowUp",
  ENTER: "Enter",
  ESCAPE: "Escape",
  SPACE: "Space"
};
import { useCallback as Ge, useEffect as fe, useMemo as he, useRef as Y, useState as F } from "react";
var le = function le(e, n) {
  var t;
  return function () {
    for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
      r[_key] = arguments[_key];
    }
    clearTimeout(t), t = setTimeout(function () {
      e.apply(null, r);
    }, n);
  };
};
function ie(e, n) {
  return n ? e.filter(function (_ref3) {
    var t = _ref3.label,
      r = _ref3.value;
    return t != null && r != null && t.toLowerCase().includes(n.toLowerCase());
  }) : e;
}
import { jsx as ce, jsxs as Be } from "react/jsx-runtime";
var T = function T() {
  return Be("svg", {
    width: "24",
    height: "24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    className: "dropdown-search-clear-icon gray",
    children: [ce("line", {
      x1: "18",
      y1: "6",
      x2: "6",
      y2: "18"
    }), ce("line", {
      x1: "6",
      y1: "6",
      x2: "18",
      y2: "18"
    })]
  });
};
import { useRef as $e } from "react";
import { jsx as de, jsxs as Ve } from "react/jsx-runtime";
var Ue = function Ue(_ref4) {
    var e = _ref4.checked,
      n = _ref4.option,
      t = _ref4.onClick,
      r = _ref4.disabled;
    return Ve("div", {
      className: "item-renderer ".concat(r ? "disabled" : ""),
      children: [de("input", {
        type: "checkbox",
        onChange: t,
        checked: e,
        tabIndex: -1,
        disabled: r
      }), de("span", {
        children: n.label
      })]
    });
  },
  pe = Ue;
import { jsx as me } from "react/jsx-runtime";
var Ye = function Ye(_ref5) {
    var _ref5$itemRenderer = _ref5.itemRenderer,
      e = _ref5$itemRenderer === void 0 ? pe : _ref5$itemRenderer,
      n = _ref5.option,
      t = _ref5.checked,
      r = _ref5.tabIndex,
      a = _ref5.disabled,
      c = _ref5.onSelectionChanged,
      u = _ref5.onClick;
    var b = $e(),
      s = function s(l) {
        p(), l.preventDefault();
      },
      p = function p() {
        a || c(!t);
      },
      i = function i(l) {
        p(), u(l);
      };
    return R([f.ENTER, f.SPACE], s, {
      target: b
    }), me("label", {
      className: "select-item ".concat(t ? "selected" : ""),
      role: "option",
      "aria-selected": t,
      tabIndex: r,
      ref: b,
      children: me(e, {
        option: n,
        checked: t,
        onClick: i,
        disabled: a
      })
    });
  },
  N = Ye;
import { Fragment as qe, jsx as $ } from "react/jsx-runtime";
var ze = function ze(_ref6) {
    var e = _ref6.options,
      n = _ref6.onClick,
      t = _ref6.skipIndex;
    var _w = w(),
      r = _w.disabled,
      a = _w.value,
      c = _w.onChange,
      u = _w.ItemRenderer,
      b = function b(s, p) {
        r || c(p ? [].concat(_toConsumableArray(a), [s]) : a.filter(function (i) {
          return i.value !== s.value;
        }));
      };
    return $(qe, {
      children: e.map(function (s, p) {
        var i = p + t;
        return $("li", {
          children: $(N, {
            tabIndex: i,
            option: s,
            onSelectionChanged: function onSelectionChanged(l) {
              return b(s, l);
            },
            checked: !!a.find(function (l) {
              return l.value === s.value;
            }),
            onClick: function onClick(l) {
              return n(l, i);
            },
            itemRenderer: u,
            disabled: s.disabled || r
          })
        }, (s == null ? void 0 : s.key) || p);
      })
    });
  },
  ue = ze;
import { jsx as k, jsxs as z } from "react/jsx-runtime";
var Je = function Je() {
    var _w2 = w(),
      e = _w2.t,
      n = _w2.onChange,
      t = _w2.options,
      r = _w2.setOptions,
      a = _w2.value,
      c = _w2.filterOptions,
      u = _w2.ItemRenderer,
      b = _w2.disabled,
      s = _w2.disableSearch,
      p = _w2.hasSelectAll,
      i = _w2.ClearIcon,
      l = _w2.debounceDuration,
      L = _w2.isCreatable,
      y = _w2.onCreateOption,
      O = Y(),
      g = Y(),
      _F = F(""),
      _F2 = _slicedToArray(_F, 2),
      m = _F2[0],
      M = _F2[1],
      _F3 = F(t),
      _F4 = _slicedToArray(_F3, 2),
      v = _F4[0],
      K = _F4[1],
      _F5 = F(""),
      _F6 = _slicedToArray(_F5, 2),
      x = _F6[0],
      D = _F6[1],
      _F7 = F(0),
      _F8 = _slicedToArray(_F7, 2),
      E = _F8[0],
      I = _F8[1],
      W = Ge(le(function (o) {
        return D(o);
      }, l), []),
      A = he(function () {
        var o = 0;
        return s || (o += 1), p && (o += 1), o;
      }, [s, p]),
      _ = {
        label: e(m ? "selectAllFiltered" : "selectAll"),
        value: ""
      },
      H = function H(o) {
        var d = v.filter(function (C) {
          return !C.disabled;
        }).map(function (C) {
          return C.value;
        });
        if (o) {
          var Ae = [].concat(_toConsumableArray(a.map(function (U) {
            return U.value;
          })), _toConsumableArray(d));
          return (c ? v : t).filter(function (U) {
            return Ae.includes(U.value);
          });
        }
        return a.filter(function (C) {
          return !d.includes(C.value);
        });
      },
      B = function B(o) {
        var d = H(o);
        n(d);
      },
      h = function h(o) {
        W(o.target.value), M(o.target.value), I(0);
      },
      P = function P() {
        var o;
        D(""), M(""), (o = g == null ? void 0 : g.current) == null || o.focus();
      },
      Z = function Z(o) {
        return I(o);
      },
      we = function we(o) {
        switch (o.code) {
          case f.ARROW_UP:
            ee(-1);
            break;
          case f.ARROW_DOWN:
            ee(1);
            break;
          default:
            return;
        }
        o.stopPropagation(), o.preventDefault();
      };
    R([f.ARROW_DOWN, f.ARROW_UP], we, {
      target: O
    });
    var Oe = function Oe() {
        I(0);
      },
      j = /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var o;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  o = {
                    label: m,
                    value: m,
                    __isNew__: !0
                  };
                  _context.t0 = y;
                  if (!_context.t0) {
                    _context.next = 6;
                    break;
                  }
                  _context.next = 5;
                  return y(m);
                case 5:
                  o = _context.sent;
                case 6:
                  r([o].concat(_toConsumableArray(t)));
                  P();
                  n([].concat(_toConsumableArray(a), [o]));
                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return function j() {
          return _ref7.apply(this, arguments);
        };
      }(),
      Re = /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!c) {
                    _context2.next = 6;
                    break;
                  }
                  _context2.next = 3;
                  return c(t, x);
                case 3:
                  _context2.t0 = _context2.sent;
                  _context2.next = 7;
                  break;
                case 6:
                  _context2.t0 = ie(t, x);
                case 7:
                  return _context2.abrupt("return", _context2.t0);
                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return function Re() {
          return _ref8.apply(this, arguments);
        };
      }(),
      ee = function ee(o) {
        var d = E + o;
        d = Math.max(0, d), d = Math.min(d, t.length + Math.max(A - 1, 0)), I(d);
      };
    fe(function () {
      var o, d;
      (d = (o = O == null ? void 0 : O.current) == null ? void 0 : o.querySelector("[tabIndex='".concat(E, "']"))) == null || d.focus();
    }, [E]);
    var _he = he(function () {
        var o = v.filter(function (d) {
          return !d.disabled;
        });
        return [o.every(function (d) {
          return a.findIndex(function (C) {
            return C.value === d.value;
          }) !== -1;
        }), o.length !== 0];
      }, [v, a]),
      _he2 = _slicedToArray(_he, 2),
      ke = _he2[0],
      Ee = _he2[1];
    fe(function () {
      Re().then(K);
    }, [x, t]);
    var te = Y();
    R([f.ENTER], j, {
      target: te
    });
    var Ie = L && m && !v.some(function (o) {
      return (o == null ? void 0 : o.value) === m;
    });
    return z("div", {
      className: "select-panel",
      role: "listbox",
      ref: O,
      children: [!s && z("div", {
        className: "search",
        children: [k("input", {
          placeholder: e("search"),
          type: "text",
          "aria-describedby": e("search"),
          onChange: h,
          onFocus: Oe,
          value: m,
          ref: g,
          tabIndex: 0
        }), k("button", {
          type: "button",
          className: "search-clear-button",
          hidden: !m,
          onClick: P,
          "aria-label": e("clearSearch"),
          children: i || k(T, {})
        })]
      }), z("ul", {
        className: "options",
        children: [p && Ee && k(N, {
          tabIndex: A === 1 ? 0 : 1,
          checked: ke,
          option: _,
          onSelectionChanged: B,
          onClick: function onClick() {
            return Z(1);
          },
          itemRenderer: u,
          disabled: b
        }), v.length ? k(ue, {
          skipIndex: A,
          options: v,
          onClick: function onClick(o, d) {
            return Z(d);
          }
        }) : Ie ? k("li", {
          onClick: j,
          className: "select-item creatable",
          tabIndex: 1,
          ref: te,
          children: "".concat(e("create"), " \"").concat(m, "\"")
        }) : k("li", {
          className: "no-options",
          children: e("noOptions")
        })]
      })]
    });
  },
  q = Je;
import { jsx as be } from "react/jsx-runtime";
var ge = function ge(_ref9) {
  var e = _ref9.expanded;
  return be("svg", {
    width: "24",
    height: "24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    className: "dropdown-heading-dropdown-arrow gray",
    children: be("path", {
      d: e ? "M18 15 12 9 6 15" : "M6 9L12 15 18 9"
    })
  });
};
import { jsx as ve } from "react/jsx-runtime";
var xe = function xe() {
  var _w3 = w(),
    e = _w3.t,
    n = _w3.value,
    t = _w3.options,
    r = _w3.valueRenderer,
    a = n.length === 0,
    c = n.length === t.length,
    u = r && r(n, t);
  return a ? ve("span", {
    className: "gray",
    children: u || e("selectSomeItems")
  }) : ve("span", {
    children: u || (c ? e("allItemsAreSelected") : function () {
      return n.map(function (s) {
        return s.label;
      }).join(", ");
    }())
  });
};
import { jsx as G } from "react/jsx-runtime";
var Se = function Se(_ref10) {
  var _ref10$size = _ref10.size,
    e = _ref10$size === void 0 ? 24 : _ref10$size;
  return G("span", {
    style: {
      width: e,
      marginRight: "0.2rem"
    },
    children: G("svg", {
      width: e,
      height: e,
      className: "spinner",
      viewBox: "0 0 50 50",
      style: {
        display: "inline",
        verticalAlign: "middle"
      },
      children: G("circle", {
        cx: "25",
        cy: "25",
        r: "20",
        fill: "none",
        className: "path"
      })
    })
  });
};
import { jsx as S, jsxs as Ce } from "react/jsx-runtime";
var Xe = function Xe() {
    var _w4 = w(),
      e = _w4.t,
      n = _w4.onMenuToggle,
      t = _w4.ArrowRenderer,
      r = _w4.shouldToggleOnHover,
      a = _w4.isLoading,
      c = _w4.disabled,
      u = _w4.onChange,
      b = _w4.labelledBy,
      s = _w4.value,
      p = _w4.isOpen,
      i = _w4.defaultIsOpen,
      l = _w4.ClearSelectedIcon,
      L = _w4.closeOnChangedValue;
    ye(function () {
      L && m(!1);
    }, [s]);
    var _J = J(!0),
      _J2 = _slicedToArray(_J, 2),
      y = _J2[0],
      O = _J2[1],
      _J3 = J(i),
      _J4 = _slicedToArray(_J3, 2),
      g = _J4[0],
      m = _J4[1],
      _J5 = J(!1),
      _J6 = _slicedToArray(_J5, 2),
      M = _J6[0],
      v = _J6[1],
      K = t || ge,
      x = Qe();
    se(function () {
      n && n(g);
    }, [g]), ye(function () {
      i === void 0 && typeof p == "boolean" && (O(!1), m(p));
    }, [p]);
    var D = function D(h) {
      var P;
      ["text", "button"].includes(h.target.type) && [f.SPACE, f.ENTER].includes(h.code) || (y && (h.code === f.ESCAPE ? (m(!1), (P = x == null ? void 0 : x.current) == null || P.focus()) : m(!0)), h.preventDefault());
    };
    R([f.ENTER, f.ARROW_DOWN, f.SPACE, f.ESCAPE], D, {
      target: x
    });
    var E = function E(h) {
        y && r && m(h);
      },
      I = function I() {
        return !M && v(!0);
      },
      W = function W(h) {
        !h.currentTarget.contains(h.relatedTarget) && y && (v(!1), m(!1));
      },
      A = function A() {
        return E(!0);
      },
      _ = function _() {
        return E(!1);
      },
      H = function H() {
        y && m(a || c ? !1 : !g);
      },
      B = function B(h) {
        h.stopPropagation(), u([]), y && m(!1);
      };
    return Ce("div", {
      tabIndex: 0,
      className: "dropdown-container",
      "aria-labelledby": b,
      "aria-expanded": g,
      "aria-readonly": !0,
      "aria-disabled": c,
      ref: x,
      onFocus: I,
      onBlur: W,
      onMouseEnter: A,
      onMouseLeave: _,
      children: [Ce("div", {
        className: "dropdown-heading",
        onClick: H,
        children: [S("div", {
          className: "dropdown-heading-value",
          children: S(xe, {})
        }), a && S(Se, {}), s.length > 0 && l !== null && S("button", {
          type: "button",
          className: "clear-selected-button",
          onClick: B,
          disabled: c,
          "aria-label": e("clearSelected"),
          children: l || S(T, {})
        }), S(K, {
          expanded: g
        })]
      }), g && S("div", {
        className: "dropdown-content",
        children: S("div", {
          className: "panel-content",
          children: S(q, {})
        })
      })]
    });
  },
  Q = Xe;
import { jsx as X } from "react/jsx-runtime";
var Ze = function Ze(e) {
    return X(ne, {
      props: e,
      children: X("div", {
        className: "rmsc ".concat(e.className || "multi-select"),
        children: X(Q, {})
      })
    });
  },
  je = Ze;
export { Q as Dropdown, je as MultiSelect, N as SelectItem, q as SelectPanel };